module.exports = __webpack_public_path__ + "img/center back length from high waist to hem.e8007093.png";